import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface IInputGroupAdvertisementFilter {
  search?: string;
  selected_cities_id?: string;
  input_guid: IInputGroupsFilter[];
  order_by: string;
  has_store: boolean;
  has_price: boolean;
  start_price: number;
  end_price?: number;
  has_immediate: boolean;
  has_special_offer: boolean;
  advertisement_type?: string;
}

export interface ISerach {
  search: string;
}

export interface IInputGroupsFilter {
  guid: string;
  title: string;
}

const initialState: IInputGroupAdvertisementFilter = {
  search: '',
  selected_cities_id: '',
  input_guid: [],
  order_by: '',
  has_store: false,
  has_price: false,
  has_immediate: false,
  has_special_offer: false,
  start_price: 0,
  // end_price: 999000000,
};
// TODO: Remove
export const InputGroupAdvertisementSlice = createSlice({
  name: 'inputGroupAdvertisement',
  initialState,
  reducers: {
    findAdvertisementList: (
      state,
      action: PayloadAction<IInputGroupAdvertisementFilter>,
    ) => {
      state.selected_cities_id = action.payload.selected_cities_id;
      state.input_guid = action.payload.input_guid;
      state.order_by = action.payload.order_by;
      state.has_store = action.payload.has_store;
      state.has_price = action.payload.has_price;
      state.start_price = action.payload.start_price;
      state.end_price = action.payload.end_price;
      state.has_immediate = action.payload.has_immediate;
      state.has_special_offer = action.payload.has_special_offer;
    },
    findAdvertisementListBySearch: (state, action: PayloadAction<ISerach>) => {
      state.search = action.payload.search;
    },
    addingFilterInputGuid: (
      state,
      action: PayloadAction<IInputGroupsFilter[]>,
    ) => {
      state.input_guid = action.payload;
    },
    clearAdvertisementList: state => {
      state.selected_cities_id = '';
      state.input_guid = [];
      state.order_by = '';
      state.has_store = false;
      state.has_price = false;
      state.start_price = 0;
      state.end_price = 999000000;
      state.has_immediate = false;
      state.has_special_offer = false;
    },
  },
});

export const {
  findAdvertisementList,
  findAdvertisementListBySearch,
  clearAdvertisementList,
  addingFilterInputGuid,
} = InputGroupAdvertisementSlice.actions;

export default InputGroupAdvertisementSlice.reducer;
